import * as React from "react";

// importing material UI components
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import { Grid2 } from "@mui/material";
// sx={{ bottom: 0, position: 'fixed', width: '100%', backgroundColor: '#1976d2', color: 'white'}}

export default function Footer() {
  return (
    <Grid2 display="none" justifyContent="center" alignItems="center" size="grow" sx={{ paddingTop: '50px' }}>
      <BottomNavigation
        showLabels
      >
        <BottomNavigationAction sx={{ color: 'black', backgroundColor:'#e4e4e4' }} label="Recents" > Recents </BottomNavigationAction>
        <BottomNavigationAction sx={{ color: 'black', backgroundColor:'#e4e4e4' }} label="Favorites" > Favorites </BottomNavigationAction>
        <BottomNavigationAction sx={{ color: 'black', backgroundColor:'#e4e4e4' }} label="Nearby" > Nearby </BottomNavigationAction>
      </BottomNavigation>
    </Grid2>
  );
};